<script setup lang="ts">
import type { ElementalQuery } from '~~/src/api/elementals'
import { useElementalsInfiniteQuery } from '~~/src/composables/query/elementals/useElementalsQuery'

const props = defineProps<{
  search: string
  name: string
  type: ElementalTypeEnum
  orderBy: ElementalQuery['order_by']
}>()

const search = toRef(props, 'search')
const orderBy = toRef(props, 'orderBy')

const promptsQuery = computed(() => {
  return {
    search: search.value,
    order_by: orderBy.value,
    elemental_type_id: props.type,
    size: 10,
  } as ElementalQuery
})
const { data: prompts, isPending } = useElementalsInfiniteQuery({
  query: promptsQuery,
}, {
  enable: computed(() => search.value.trim() !== ''),
})

const result = computed(() => {
  if (search.value.trim() === '')
    return []
  return prompts.value?.pages[0] ?? []
})
</script>

<template>
  <AppTab :name="name" :count="result.length" overflow-auto>
    <PromptList :elementals="result" variant="preview" :loading="isPending" :is-searching="!!search" />
  </AppTab>
</template>
